import { render } from "./CategorieEdit.vue?vue&type=template&id=2890b5f4"
import script from "./CategorieEdit.vue?vue&type=script&lang=js"
export * from "./CategorieEdit.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__